import React from 'react';
import Textfield from 'react-mdl/lib/Textfield';
import { List, ListItem } from 'react-mdl/lib/List';
import { Card } from 'react-mdl/lib/Card';

export default class AutoComplete extends React.Component {
  constructor(props) {
    super(props);

    this.state = { value: '' };
  }

  onSelect(match) {
    this.setState({
      focused: false,
      value: match
    });
    this.props.onNewRequest(match);
  }

  onChange(e) {
    this.setState({
      value: e.target.value
    });
  }

  render() {
    const {
      filter, dataSource, hintText, maxSearchResults,
      id, fullWidth
    } = this.props;
    const currentValue = this.state.focused ? this.state.value : (this.props.searchText || '');
    const matches = dataSource.filter(
      value => currentValue &&
        currentValue.length > 0 &&
        filter(currentValue, value)
    ).slice(0, maxSearchResults);

    return (
      <div className={fullWidth ? 'AutoComplete-full-width' : ''} id={`${id}-container`}>
        <Textfield
          onChange={this.onChange.bind(this)}
          onFocus={() => {
            this.setState({ focused: true, value: '' });
            if(screen.width < 740) {
              document.getElementById(`${id}-container`).scrollIntoView();
            }
          }}
          onBlur={() => this.setState({ focused: false })}
          label={hintText}
          floatingLabel
          value={currentValue}
          id={id}
        />

        {!this.state.focused || !matches.length ? null :
          <Card shadow={0}>
            <List>
              {matches.map(match =>
                <ListItem onMouseDown={() => this.onSelect(match)} style={{ cursor: 'pointer' }}>
                  {match}
                </ListItem>
              )}
            </List>
          </Card>
        }
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/AutoComplete.js
 **/